const accessVisitor = {
    GATE_OPERATIONS: { name: 'Gate Operations', path: '/gate-operations' },
    VISITOR_MONITORING: { name: 'Visitor Monitoring', path: '/visitor-monitoring' },
    IN_OUT_BOOK: { name: 'In/Out Book', path: '/in-out-book' },
    IN_OUT_DETAILS: { name: 'In/Out Details', path: '/in-out-details' },
    IN_OUT_ENTRIES: { name: 'In/Out Entries', path: '/in-out-entries' },
    VISTOR_GATEPASS: { name: 'Visitor & Gate Pass', path: '/visitor-gate-pass' },
    PRE_APPROVED_VISITOR_LIST: { name: 'Pre Approved Visitor', path: '/pre-approved-visitor' },
    ADD_PRE_APPROVED_VISITOR: { name: 'Add Pre Approved Visitor', path: '/create-pre-approved-visitor' },
    UPDATE_PRE_APPROVED_VISITOR: { name: 'Update Pre Approved Visitor', path: '/edit-pre-approved-visitor' },
    DELETE_PRE_APPROVED_VISITOR: { name: 'Delete Pre Approved Visitor', path: '/delete-pre-approved-visitor' },

    VISITOR_APPROVAL_REQUESTS_LIST: { name: 'Visitor Approval Requests', path: '/visitor-approval-requests' },

    MY_VISITOR_LIST: { name: 'My Visitors', path: '/my-visitors' },

    OVER_STAY_LIST: { name: 'Over Stay List', path: '/over-stay-list' },
    VISITOR_MANAGEMENT_SYSTEM: { name: 'Visitor Management', path: '/visitor-management' },
    DIRECTORY_AND_STAFF: { name: 'Directory & Staff', path: '/directory-and-staff' },
}

export default accessVisitor;